import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaMovimientosDetallado', NominasNominaMovimientosDetallado)

function NominasNominaMovimientosDetallado($q, $interpolate, $catalogos, $state, $filter, NominasNominaMovimientos) {
  this.get = _get

  function _get(idEmpresa, idNomina) {
    return $q.all({
      empleados: NominasNominaMovimientos.get(idEmpresa, idNomina),
      conceptos: $catalogos.get('movimientos'),
    }).then(function ($resolve) {
      return generarGrid($resolve.empleados.data, $resolve.conceptos)
    })
  }

  function generarGrid(empleados, conceptos) {
    let gridData = {
      pinnedColumnCount: 1,
      enableColResize: true,
      rowSelection: 'single',
      columnDefs: obtenerColumnas(),
      rowData: obtenerData(),
      icons: {
        groupExpanded: '<i class="fa fa-chevron-down fa-fw"></i>',
        groupContracted: '<i class="fa fa-chevron-right fa-fw"></i>',
      },
      groupUseEntireRow: false,
      groupKeys: ['cobro_carga_social'],
      groupHeaders: true,
      groupDefaultExpanded: true,
      groupColumnDef: {
        headerName: 'Empleado',
        field: 'empleado',
        width: 300,
        minWidth: 200,
        cellRenderer: {
          renderer: 'group',
          padding: 10,
          innerRenderer: empleadoRenderer,
        },
      },
    }

    function obtenerConceptos() {
      let data = []

      empleados.forEach(function (empleado) {
        ['deducciones', 'percepciones'].forEach(function (naturaleza) {
          angular.forEach(empleado[naturaleza], function (value, idConcepto) {
            if (data.indexOf(idConcepto) < 0)
              data.push(idConcepto)
          })
        })
      })

      return data.map(function (idConcepto) {
        return conceptos.find(function (concepto) {
          return concepto.id == idConcepto
        })
      }).filter(function (item) {
        return item
      })
    }

    function obtenerData() {
      return $filter('orderBy')(empleados.map(function (empleado) {
        let data = {
          id_empresa: empleado.id_empresa,
          id_empleado: empleado.id_empleado,
          empleado: empleado.empleado,
          empresa: empleado.empresa,
          neto: empleado.neto_a_pagar,
          impuesto_estatal: empleado.impuesto_estatal,
          carga_social: empleado.carga_social,
          cobro_carga_social: empleado.cobro_carga_social ? 'No remunerados' : 'Empleados remunerados',
        };

        ['percepciones', 'deducciones'].forEach(function (naturaleza) {
          angular.forEach(empleado[naturaleza], function (value, idConcepto) {
            if (!empleado.cobro_carga_social || (empleado.cobro_carga_social && idConcepto != 2 && idConcepto != 164))
              data[idConcepto] = value.importe
          })
        })

        return data
      }), 'cobro_carga_social')
    }

    function obtenerColumnas() {
      let conceptos = obtenerConceptos(),
        percepciones = conceptos.filter(function (concepto) {
          return concepto.naturaleza === 'P'
        }),
        deducciones = conceptos.filter(function (concepto) {
          return concepto.naturaleza === 'D'
        })

      return [{
        headerName: 'ID',
        field: 'id_empleado',
        hide: true,
      }, {
        headerName: 'Empleado',
        field: 'empleado',
        hide: true,
      }].concat(percepciones.map(function (concepto) {
          return {
            headerName: concepto.concepto,
            field: concepto.id,
            width: 90,
            minWidth: 80,
            cellRenderer: currencyRenderer,
            headerTooltip: concepto.id + ' - ' + concepto.concepto,
            headerGroup: 'Percepciones',
            aggFunc: 'sum',
          }
        }))
        .concat(deducciones.map(function (concepto) {
          return {
            headerName: concepto.concepto,
            field: concepto.id,
            width: 90,
            minWidth: 80,
            cellRenderer: currencyRenderer,
            headerTooltip: concepto.id + ' - ' + concepto.concepto,
            headerGroup: 'Deducciones',
            aggFunc: 'sum',
          }
        }))
        .concat([{
          headerName: 'Neto',
          field: 'neto',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          aggFunc: 'sum',
        }, {
          headerName: 'Impuesto Estatal',
          field: 'impuesto_estatal',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          aggFunc: 'sum',
        }, {
          headerName: 'Carga Social',
          field: 'carga_social',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
          aggFunc: 'sum',
        }])
    }

    let currencyRendererTemplate = '<div class="text-light" align="right"><span float="left">$</span> &dash;&nbsp;&nbsp;</div>',
      currencyRendererTemplatePos = $interpolate('<div align="right"><span float="left">$</span> {{(importe || 0) | currency: ""}}</div>'),
      currencyRendererTemplateNeg = $interpolate('<div style="color: red" align="right"><span float="left">$</span> {{(importe || 0) | currency: ""}}</div>'),
      empleadoRendererTemplate = $interpolate('<a class="link tag" href="{{::link}}" style="text-align:center;width:50px;line-height:1.5;margin-right:4px" target="_blank" title="Informaci&oacute;n del Kardex"><code>{{id_empleado}}</code></a> {{empleado}}')

    function currencyRenderer(params) {
      if (params.value > 0)
        return currencyRendererTemplatePos({importe: params.value})
      else if (params.value < 0)
        return currencyRendererTemplateNeg({importe: params.value})
      else
        return currencyRendererTemplate
    }

    function empleadoRenderer(params) {
      if (params.node.group)
        return params.node.key
      else
        return empleadoRendererTemplate({
          id_empleado: params.data.id_empleado,
          empleado: params.data.empleado,
          link: $state.href('empleado', {idEmpresa: params.data.id_empresa, idEmpleado: params.data.id_empleado}),
        })
    }

    return gridData
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Movimientos/Detallado.js